<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
    />
    <path d="M12 8v4M12 16h.01" />
  </svg>
</template>

<script>
export default {
  name: 'IconInfoCircle',
  props: {
    size: { type: [String, Number], default: 16 },
    strokeWidth: { type: [String, Number], default: 2.4 },
  },
};
</script>
